/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type NpsByAnswerToOtherQuestionBarChart_answersReport = {|
  +npsByAnswerToOtherQuestion: ?$ReadOnlyArray<?{|
    +text: ?$ReadOnlyArray<?{|
      +language: ?string;
      +text: ?string;
    |}>;
    +nps: ?number;
    +count: ?number;
  |}>;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "otherQuestionMongoId",
      "type": "ID"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "NpsByAnswerToOtherQuestionBarChart_answersReport",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "otherQuestionMongoId",
          "variableName": "otherQuestionMongoId",
          "type": "ID"
        }
      ],
      "concreteType": "NpsByAnswerToOtherQuestion",
      "name": "npsByAnswerToOtherQuestion",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Translation",
          "name": "text",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "language",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "text",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "nps",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswersReport"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/NpsByAnswerToOtherQuestionBarChart/__generated__/NpsByAnswerToOtherQuestionBarChart_answersReport.graphql.js